{
  "_license": "Copyright (c) 2025 Goffy. This file belongs to Goffy. All Rights Reserved.",
  "course": {
    "error": "Kan inte ladda golfklubbar",
    "insecure": "Using a default location (needs HTTPS for precise location).",
    "label": "Använd närmaste golfklubb",
    "enableLocationHint": "(Aktivera plats för detta)",
    "loading": "Hitta golfklubbar",
    "none": "Inga golfklubbar i närheten",
    "permissionDenied": "Platsbehörigheter nekade",
    "helpLabel": "Hjälp för plats",
    "helpTitle": "Aktivera plats för närmaste golfklubb",
    "helpDescription": "Tillåt platsåtkomst i webbläsaren eller enhetens inställningar för att automatiskt hitta klubbar i närheten.",
    "refresh": "Uppdatera",
    "select": "Välj golfklubb"
  },
  "appError": {
    "title": "Något gick fel",
    "message": "Ladda om sidan. Om problemet kvarstår, kontakta support.",
    "retry": "Försök igen"
  },
  "edit": {
    "autosave": "Ändra texten, spara filen så uppdateras din app automatiskt.",
    "help": "Tryck här om din app inte uppdateras automatiskt efter att du har gjort ändringar",
    "openCode": "Öppna koden för den här skärmen:"
  },
  "menu": {
    "profile": "Profil",
    "about": "Om",
    "aboutTitle": "Tjänststatus",
    "aboutLoading": "Hämtar status...",
    "aboutEmpty": "Ingen statusdata tillgänglig.",
    "aboutError": "Fel:",
    "aboutLoadError": "Kunde inte hämta status.",
    "aboutUnknownService": "Okänd tjänst",
    "aboutUnknownImage": "Okänd bild",
    "home": "Hem",
    "friends": "Vänner",
    "hole": "Hål",
    "selectGames": "Välj spel",
    "tour": "Tour",
    "configCourse": "Konfigurera bana",
    "roundResults": "Runda",
    "scorecard": "Scorekort",
    "more": "Meny",
    "back": "<- Tillbaka",
    "logout": "Logga ut",
    "close": "Stäng",
    "anonymous": "Gäst",
    "reportBug": "Rapportera bugg",
    "reportBugTitle": "Rapportera bugg",
    "reportBugHint": "Beskriv vad som hände. Inkludera förväntat och faktiskt resultat.",
    "reportBugDescriptionPlaceholder": "Vad hände? Vad förväntade du dig?",
    "reportBugAddImage": "Lägg till bild",
    "reportBugRemoveImage": "Ta bort bild",
    "reportBugPasteHint": "Tips: klistra in en bild från urklipp när den här dialogen är öppen.",
    "reportBugSend": "Skicka rapport",
    "reportBugSending": "Skickar...",
    "reportBugSent": "Buggrapport skickad till Slack #bugs.",
    "reportBugSendFailed": "Kunde inte skicka buggrapport",
    "reportBugInvalidImage": "Endast bildfiler stöds.",
    "reportBugImageTooLarge": "Bilden är för stor (max 8 MB).",
    "reportBugMissingContent": "Lägg till en beskrivning eller bild innan du skickar.",
    "reportBugFileUnsupported": "Filuppladdning stöds bara på webben."
  },
  "profile": {
    "title": "Profil",
    "loading": "Hämtar profil...",
    "loadFailed": "Kunde inte hämta profil.",
    "nameLabel": "Namn",
    "namePlaceholder": "Ange ditt namn",
    "emailLabel": "E-post",
    "emailPlaceholder": "namn@example.com",
    "genderLabel": "Kön",
    "genderPlaceholder": "man, kvinna eller annat",
    "genderMale": "Man",
    "genderFemale": "Kvinna",
    "genderNeutral": "Neutral",
    "handicapLabel": "Handicap",
    "handicapPlaceholder": "t.ex. 12,4",
    "handicapDateLabel": "Handicapdatum",
    "handicapDatePlaceholder": "ÅÅÅÅ-MM-DD",
    "imageLabel": "Profilbild",
    "uploadImage": "Ladda upp bild",
    "selectAvatar": "Välj avatar",
    "removeAvatar": "Ta bort avatar",
    "avatarPickerTitle": "Välj en avatar",
    "avatarMore": "Fler",
    "avatarLoading": "Laddar avatarer...",
    "close": "Stäng",
    "save": "Spara",
    "saving": "Sparar...",
    "saveSuccess": "Profil sparad.",
    "saveFailed": "Kunde inte spara profil.",
    "handicapRequired": "Ange handicap när handicapdatum är satt.",
    "handicapDateRequired": "Ange handicapdatum när handicap är satt.",
    "invalidHandicap": "Ange ett giltigt handicapvärde.",
    "invalidHandicapDate": "Ange ett giltigt handicapdatum (ÅÅÅÅ-MM-DD).",
    "homeClubsLabel": "Hemmklubbar",
    "homeClubsEmpty": "Inga hemmklubbar valda.",
    "homeClubsAdd": "Lägg till hemmklubb",
    "homeClubsPrimary": "Primär",
    "homeClubsSetPrimary": "Sätt som primär",
    "homeClubsRemove": "Ta bort",
    "homeClubsPickerTitle": "Välj hemmklubb",
    "homeClubsSearchPlaceholder": "Sök klubb...",
    "homeClubsLoading": "Laddar klubbar...",
    "homeClubsNoResults": "Inga klubbar hittades.",
    "homeClubsUnknownLocation": "Okänd plats",
    "homeClubsRefresh": "Uppdatera",
    "homeClubsLoadFailed": "Kunde inte ladda klubbar.",
    "uploading": "Laddar upp bild...",
    "uploadSuccess": "Bild uppladdad.",
    "uploadFailed": "Kunde inte ladda upp bild.",
    "permissionDenied": "Behov av fotobibliotekstillstånd."
  },
  "teamDraw": {
    "title": "Lottade lag"
  },
  "serviceStatus": {
    "buttonLabel": "Tjänststatus",
    "alert": "!",
    "title": "Tjänster saknas",
    "allOk": "Alla tjänster är igång.",
    "warningsFound": "Varningar eller fel hittades i loggar.",
    "unknownTimestamp": "Okänd tidpunkt",
    "unknownService": "Okänd tjänst",
    "unknownBody": "Ingen loggtext",
    "continueMissing": "Fortsätt (saknas: {missing})",
    "close": "Stäng",
    "checkedAt": "Kontrollerad: {time}",
    "bffName": "backend-for-frontend-service"
  },
  "debug": {
    "button": "Debug",
    "buttonLabel": "Debug-information",
    "title": "Debug-info",
    "userLabel": "Användare",
    "userIdLabel": "Användar-ID",
    "playerIdLabel": "Spelar-ID",
    "roundLabel": "Rond-ID",
    "roundNameLabel": "Rondnamn",
    "tourLabel": "Tour-ID",
    "tourNameLabel": "Tournamn",
    "holeViewTraceLabel": "TraceId hålvy",
    "holeScoreTraceLabel": "TraceId hålscore",
    "traceNone": "Ingen",
    "copyIdsLabel": "Kopiera debug-ID",
    "copyIdLabel": "Kopiera {label}",
    "loading": "Hämtar namn...",
    "unknown": "Okänt",
    "close": "Stäng",
    "disable": "Stäng av debug",
    "resetCoachMarks": "Återställ coach marks",
    "resetCoachMarksRunning": "Återställer coach marks...",
    "resetCoachMarksSuccess": "Coach marks återställda för användaren.",
    "resetCoachMarksError": "Kunde inte återställa coach marks.",
    "coachMarksTitle": "Coach marks",
    "coachMarksEmpty": "Inga coach marks laddades.",
    "coachMarkLabel": "Coach mark: {key}",
    "deeplinkTitle": "Deep link-debugg",
    "deeplinkPlatform": "Plattform",
    "deeplinkLatest": "Senaste URL",
    "deeplinkEmpty": "Ingen deep link mottagen ännu."
  },
  "welcome": {
    "title": "Välkommen",
    "body": "Välj hur du vill starta: skapa en enkel runda, starta en ny tour eller öppna dina befintliga tours och ej avslutade rundor.",
    "startSingleRound": "Starta enkel runda",
    "startTour": "Starta tour",
    "myTours": "Mina tours och rundor",
    "myToursOpenSummary": "Öppna tours: {tours} · Enkla rundor: {singleRounds}",
    "myToursNav": "Mina rundor"
  },
  "friends": {
    "title": "Vänner",
    "loading": "Laddar vänner...",
    "empty": "Inga vänner tillagda ännu.",
    "myFriends": "Mina vänner",
    "linked": "Länkad användare",
    "guest": "Gästprofil",
    "addLinked": "Lägg till länkad spelare",
    "addGuest": "Lägg till gästspelare",
    "searchPlaceholder": "Sök spelare",
    "guestPlaceholder": "Gästnamn",
    "createGuestAndAdd": "Skapa gäst och lägg till",
    "add": "Lägg till",
    "remove": "Ta bort",
    "editNickname": "Redigera smeknamn",
    "cancel": "Avbryt",
    "nicknamePlaceholder": "Smeknamn (valfritt)",
    "saveNickname": "Spara smeknamn",
    "loadPlayersError": "Kunde inte ladda plattformsspelare.",
    "guestCreateFailed": "Kunde inte skapa gästspelare.",
    "actionFailed": "Kunde inte uppdatera vänner.",
    "findPlayersPlaceholder": "Hitta spelare...",
    "allFriends": "Alla vänner",
    "recent": "Senaste",
    "eliteStatus": "Elitstatus",
    "myFriendsCount": "Mina vänner {count}",
    "noMatches": "Inga vänner matchar din sökning."
  },
  "coachMarks": {
    "tournamentsCreateTitle": "Skapa din första tour",
    "tournamentsCreateBody": "Använd knappen för att skapa en ny tour och gå vidare till rundinställningar.",
    "profileImageActionsTitle": "Välj profilbild",
    "profileImageActionsBody": "Ladda upp en bild eller välj en avatar som visas tillsammans med ditt namn.",
    "holeScoreTitle": "Tips för score-raden",
    "holeScoreBody": "Tryck på Score för att öppna poänginmatning och registrera hazard- eller mystery-resultat. Du kan också svepa vänster eller höger på en spelarrad för att justera slag.",
    "gotIt": "Jag förstår"
  },
  "courseConfig": {
    "title": "Konfigurera bana",
    "clubLabel": "Klubb",
    "clubPlaceholder": "Klubbnamn",
    "courseLabel": "Bana",
    "coursePlaceholder": "Bannamn",
    "holeHeader": "Hål",
    "parHeader": "Par",
    "strokeIndexHeader": "Index",
    "teesTitle": "Tee-inställning",
    "addTeeButton": "Lägg till tee",
    "teeLabel": "Tee {index}",
    "removeTeeButton": "Ta bort",
    "teeNameLabel": "Tee-namn",
    "teeNamePlaceholder": "Gul",
    "teeGenderLabel": "Kön",
    "genderMale": "Man",
    "genderFemale": "Kvinna",
    "genderUnisex": "Unisex",
    "teeColorLabel": "Tee-färg",
    "teeColorPlaceholder": "gul",
    "teeParLabel": "Tee par",
    "courseRatingLabel": "Course rating",
    "slopeRatingLabel": "Slope rating",
    "cancelButton": "Avbryt",
    "saveButton": "Spara bana",
    "saving": "Sparar bana...",
    "waitingConnection": "Väntar på websocket-anslutning...",
    "saveSuccess": "Bana sparad {id}",
    "saveRejected": "Det gick inte att spara banan.",
    "clubRequired": "Klubbnamn måste anges.",
    "courseRequired": "Bannamn måste anges.",
    "invalidPar": "Alla hål måste ha ett parvärde.",
    "invalidStrokeIndex": "Alla hål måste ha ett index.",
    "teesRequired": "Lägg till minst en tee.",
    "teeNameRequired": "Alla tees måste ha ett namn.",
    "teeGenderRequired": "Alla tees måste ha ett kön.",
    "invalidCourseRating": "Alla tees måste ha ett giltigt course rating-värde.",
    "invalidSlopeRating": "Alla tees måste ha ett giltigt slope rating-värde.",
    "invalidTeePar": "Alla tees måste ha ett giltigt parvärde."
  },
  "tournaments": {
    "title": "Tävlingar",
    "loading": "Laddar tours...",
    "menuLabel": "Tourval",
    "showArchived": "Visa arkiverade",
    "hideArchived": "Dölj arkiverade",
    "statusContinue": "Fortsätt",
    "statusPause": "Pausa",
    "statusArchive": "Arkivera",
    "statusSleep": "Viloläge",
    "statusCancel": "Avbryt",
    "statusUpdateSent": "Uppdaterar status till {status}...",
    "statusUpdateAck": "Tourstatus uppdaterad.",
    "statusUpdateQueued": "Väntar på websocket...",
    "archiveTitle": "Tour uppdaterad",
    "archiveMessage": "Tourstatus uppdaterades.",
    "loadError": "Det gick inte att hämta tours.",
    "empty": "Ingen tour hittades. Skapa en ny.",
    "noTours": "Ingen tour hittades.",
    "defaultName": "Ny tour",
    "namePlaceholder": "Tour namn",
    "creating": "Skapar tour...",
    "createCta": "Ny tour",
    "singleRoundCta": "Enkel runda",
    "createdNotice": "Ny tour har skapats. Välj tour från listan.",
    "createdWithId": "Tour skapad: {id}",
    "createFailed": "Kunde inte skapa tour just nu. Försök igen.",
    "membersTitle": "Tourmedlemmar",
    "membersLoading": "Laddar spelare...",
    "membersCount": "Valda: {selected}/{max}",
    "membersLoadError": "Det gick inte att ladda plattformsspelare.",
    "playerProvisioning": "Skapar din spelarprofil...",
    "playerProvisioningRetry": "Spelarprofilen är försenad. Försök igen.",
    "playerProvisioningTimeout": "Tiden gick ut för att skapa spelarprofilen. Försök igen.",
    "playerProvisioningActionRetry": "Försök igen",
    "playerProvisioningBlocked": "Vänta tills din spelarprofil är klar innan du skapar en tour.",
    "creatorMemberLocked": "Din spelare är alltid med i touren och kan inte tas bort.",
    "creatorMemberRequired": "Din spelarprofil måste vara med innan du kan skapa en tour.",
    "shareCta": "Dela",
    "shareTitle": "Dela {name}",
    "shareSubtitle": "Alla med länken kan se live-resultat för touren.",
    "shareAction": "Dela länk",
    "shareClose": "Stäng",
    "shareLoadError": "Kunde inte skapa en inbjudningslänk för den här touren.",
    "shareSendError": "Det gick inte att dela inbjudningslänken på den här enheten.",
    "shareCopied": "Inbjudningslänk kopierad.",
    "openButton": "Öppna",
    "newRoundCta": "Lägg till runda",
    "roundsTitle": "Rundor",
    "unfinishedRoundsTitle": "Ej avslutade rundor",
    "hiddenToursUnfinishedRoundsTitle": "Ej avslutade rundor från dolda tours",
    "roundsLoading": "Laddar rundor...",
    "roundsEmpty": "Inga rundor hittades.",
    "roundsLoadError": "Det gick inte att ladda rundor.",
    "myToursAndRoundsSummary": "Tours: {tours} · Ej avslutade rundor: {rounds}",
    "roundFallbackName": "Runda",
    "roundOpen": "Öppna",
    "roundStart": "Starta",
    "roundUpdate": "Uppdatera",
    "roundSettings": "Rondinställningar",
    "roundResults": "Resultat",
    "roundStatus": "Status: {status}",
    "roundStatusWithDate": "Status: {status} · {date}",
    "editCta": "Redigera",
    "gamesTitle": "Spel",
    "gamesCount": "{count} spel",
    "gamesLoading": "Laddar spel...",
    "gamesEmpty": "Inga spel valda.",
    "gamesLoadError": "Det gick inte att ladda spel.",
    "groupsLoading": "Laddar grupper...",
    "groupsLoadError": "Det gick inte att ladda grupper.",
    "gameFallbackName": "Spel",
    "gameTypeUnknown": "Övrigt",
    "gameTypeLabel": "Typ:",
    "gameTypeMissing": "Typ: Okänd",
    "gameWeightLabel": "Vikt",
    "gameDetailsTitle": "Speldetaljer",
    "gameDetailsEmpty": "Ingen beskrivning tillgänglig.",
    "gameCalculationLabel": "Beräkning:",
    "addGame": "Lägg till spel",
    "addGameTitle": "Lägg till spel",
    "addGameEmpty": "Alla spel är redan tillagda."
  },
  "tourEdit": {
    "playersTitle": "Spelare",
    "addPlayer": "Lägg till spelare",
    "removePlayer": "Ta bort",
    "playerCreateTemporary": "Skapa tillfällig",
    "playerTemporarySelected": "Tillfällig vald",
    "playerSearchPlaceholder": "Sök spelare",
    "playerCurrentUserFallback": "Du",
    "playerConfirmSelectOrTemporary": "Välj en befintlig spelare eller markera som tillfällig innan du bekräftar.",
    "playerConfirmEmpty": "Ange ett spelarnamn innan du bekräftar.",
    "playerAlreadyInTour": "Spelaren finns redan i touren.",
    "playerConfirmA11y": "Bekräfta spelarrad",
    "playerCancelA11y": "Avbryt spelarrad",
    "playerTemporaryToggleA11y": "Växla tillfällig spelare",
    "playerInviteTooltip": "Bjud in",
    "playerInviteA11y": "Bjud in {name}",
    "playerInviteTitle": "Bjud in {name}",
    "playerInviteSubtitle": "Dela den här länken med {name} för att gå med i touren.",
    "playerInviteLoadError": "Kunde inte skapa en inbjudningslänk för den här spelaren.",
    "playerInviteShareError": "Det gick inte att dela inbjudningslänken.",
    "playerInviteCopied": "Inbjudningslänk kopierad.",
    "title": "Tour redigering",
    "breadcrumbTitle": "Tävling - redigering",
    "subtitle": "Webbversion",
    "backToTours": "Till tours",
    "tourIdLabel": "Tour-ID",
    "tourIdMissing": "Tour-ID saknas.",
    "webOnlyNote": "Den här sidan finns bara på webben.",
    "nameLabel": "Tour-namn",
    "namePlaceholder": "Ange tournamn",
    "saveCta": "Spara",
    "saving": "Sparar...",
    "saveSent": "Sparar tour...",
    "saveQueued": "Väntar på websocket...",
    "saveAck": "Tour uppdaterad.",
    "saveFailed": "Det gick inte att uppdatera tour.",
    "saveAll": "Spara alla",
    "saveAllSent": "Sparar alla inställningar...",
    "loading": "Laddar tour...",
    "loadError": "Det gick inte att ladda tour.",
    "nameRequired": "Ange ett tournamn.",
    "addRound": "Lägg till runda",
    "roundNameLabel": "Rundanamn",
    "roundDateLabel": "Speldatum",
    "roundDateUnset": "Välj datum",
    "roundDatePicker": "Öppna kalender",
    "roundDatePickerTitle": "Välj datum",
    "roundDatePickerToday": "Idag",
    "roundCreate": "Skapa runda",
    "roundCreateSaving": "Skapar...",
    "roundCreateFailed": "Det gick inte att skapa rundan.",
    "roundCreateNoPlayers": "Inga spelare hittades för tävlingen.",
    "roundCreatePlayerLoading": "Laddar spelare...",
    "addImage": "Lägg till bild",
    "uploadingImage": "Laddar upp bild...",
    "imageUploadFailed": "Det gick inte att ladda upp bilden.",
    "imageUploadSuccess": "Tävlingsbilden uppdaterad.",
    "roundPlayersTitle": "Rundspelare",
    "roundPlayersLoading": "Laddar rundspelare...",
    "roundPlayersEmpty": "Inga spelare i rundan ännu.",
    "memberRemoving": "Tar bort spelare från touren...",
    "memberRemoveSent": "Tar bort spelare från touren...",
    "memberRemoved": "Spelaren togs bort från touren.",
    "memberRemoveRejected": "Det gick inte att ta bort spelaren från touren.",
    "memberRemoveTimeout": "Tidsgränsen för borttagning av tourspelare överskreds.",
    "roundMemberRemoving": "Tar bort spelare från rundan...",
    "roundMemberRemoveSent": "Tar bort spelare från rundan...",
    "roundMemberRemoved": "Spelaren togs bort från rundan.",
    "roundMemberRemoveRejected": "Det gick inte att ta bort spelaren från rundan.",
    "roundMemberRemoveTimeout": "Tidsgränsen för borttagning av rundspelare överskreds.",
    "removeRound": "Ta bort runda",
    "roundRemoving": "Tar bort runda...",
    "roundRemoveSent": "Tar bort runda...",
    "roundRemoved": "Rundan togs bort.",
    "roundRemoveRejected": "Det gick inte att ta bort rundan.",
    "roundRemoveTimeout": "Tidsgränsen för borttagning av runda överskreds.",
    "roundRemoveBlockedScores": "Rundan har registrerade scorer",
    "roundRemoveA11y": "Ta bort runda",
    "roundPlayerRemoveBlockedScores": "Har registrerade scorer",
    "roundPlayerRemoveBlockedLastPlayer": "Sista spelaren i rundan",
    "roundPlayerRemoveA11y": "Ta bort spelare från rundan",
    "roundPlayerRemoveDisabledA11y": "Spelaren kan inte tas bort från rundan",
    "roundAddPlayer": "Lägg till spelare",
    "roundAddPlayerPlaceholder": "Välj tourmedlem",
    "roundAddPlayerNoCandidates": "Inga tillgängliga tourmedlemmar att lägga till.",
    "roundAddPlayerStatusBlocked": "Rundstatus tillåter inte att spelare läggs till.",
    "tournamentGamesTitle": "Turneringsspel",
    "tournamentGamesEmpty": "Inga turneringsspel valda.",
    "tournamentAddGame": "Lägg till turneringsspel",
    "tournamentRemoveGame": "Ta bort",
    "tournamentManagedLabel": "Turneringsstyrt",
    "gameDetailsPanelTitle": "Speldetaljer",
    "gameDetailsEmptyState": "Välj ett spel för att se detaljer.",
    "gameDetailsScopeLabel": "Omfattning:",
    "gameDetailsTypeLabel": "Typ:",
    "gameScopeLibrary": "Bibliotek",
    "gameScopeTournament": "Turnering",
    "gameScopeRoundLocal": "Rundlokalt",
    "cancelRound": "Avbryt",
    "done": "Klar",
    "playerSearchNoResults": "Inga spelare hittades."
  },
  "auth": {
    "loginTitle": "Logga in",
    "loginCardTitle": "Välkommen tillbaka",
    "loginCta": "Login",
    "loggingIn": "Loggar in...",
    "loginSubtitle": "Inloggning",
    "loginHint": "Du skickas till Keycloak för att logga in.",
    "debugLabel": "Inloggad",
    "debugNone": "Ingen",
    "callbackLoading": "Slutför inloggning...",
    "callbackReady": "Väntar på svar från Keycloak"
  },
  "login": {
    "userNotFound": "Din anvandare finns inte langre. Logga in igen."
  },
  "start": {
    "title": "Välkommen till Goffy",
    "subtitle": "Ange en inbjudningskod om du har en, eller fortsätt med ett nytt eller befintligt konto.",
    "roundCodeLabel": "Rundkod",
    "roundCodePlaceholder": "Ange inbjudningskod",
    "roundCodeRequired": "Ange en inbjudningskod för att fortsätta.",
    "joinWithCodeCta": "Gå med med kod",
    "signUpCta": "Skapa konto",
    "logInCta": "Logga in"
  },
  "register": {
    "title": "Skapa konto",
    "cardTitle": "Skapa ditt konto",
    "forenameLabel": "Förnamn",
    "forenamePlaceholder": "Ditt namn",
    "emailLabel": "E-post (valfritt)",
    "emailPlaceholder": "namn@example.com",
    "passwordLabel": "Lösenord",
    "passwordPlaceholder": "Minst 4 tecken",
    "creating": "Skapar...",
    "createCta": "Skapa konto",
    "connectionLabel": "BFF-anslutning: {status}",
    "connectionUp": "aktiv",
    "connectionDown": "frånkopplad",
    "backToLogin": "Till startsidan",
    "statusQueued": "Skickar förfrågan...",
    "statusSuccess": "Konto skapat! Logga in med dina uppgifter.",
    "validationMissing": "Ange namn och lösenord.",
    "connectionMissing": "Ingen anslutning till BFF. Försök igen.",
    "userExists": "En användare med den e-posten finns redan.",
    "createFailed": "Kunde inte skapa användare."
  },
  "home": {
    "addPlayers": "+ Lägg till spelare",
    "maxPlayers": "Max 8 spelare",
    "namePlaceholder": "Ange namn",
    "primaryCta": "Välj spel",
    "saveError": "Det gick inte att spara spelare.",
    "saving": "Sparande...",
    "scpPlaceholder": "SHCP",
    "scpRequired": "Ange SHCP för alla spelare.",
    "title": "Lägg till spelare",
    "playerLabel": "Spelare {index}",
    "validationRequired": "Ange minst en spelare."
  },
  "selectGames": {
    "title": "Välj spel",
    "waiting": "Väntar på tour-ID...",
    "tourIdLabel": "Aktuellt tour-ID",
    "tourLabel": "Tour",
    "roundLabel": "Runda",
    "playersLabel": "Spelare: {count}",
    "gamesLabel": "Speltyper: {count}",
    "missing": "saknas",
    "hint": "Håll skärmen öppen tills touren är klar.",
    "gameListTitle": "Välj ett spel",
    "gameInfo": "Info",
    "gameDescription": "Beskrivning",
    "infoIcon": "i",
    "infoVideoTitle": "Mystery-spel info",
    "infoVideoTitleByGame": "{name} spelinfo",
    "gameNameFallback": "Spel",
    "infoDescriptionTitle": "Beskrivning",
    "infoDescriptionEmpty": "Ingen beskrivning tillgänglig.",
    "infoDescriptionExtra": "Det här spelet räknas hål för hål och påverkar rundans totalresultat utifrån sin vikt.",
    "infoGameTypeTitle": "Speltyp",
    "infoGameTypeDefault": "Poängbaserat sidospel",
    "infoWeightTitle": "Viktinställning",
    "infoWeightValue": "Aktuell vikt: {weight}%",
    "infoWeightHelp": "Vikten styr hur mycket spelet påverkar totalpoängen. 100% ger full effekt, lägre värden minskar påverkan.",
    "closeVideo": "Stäng",
    "gameLoadError": "Kunde inte ladda spel",
    "gameStartError": "Kunde inte starta spel",
    "startGame": "Starta spel",
    "startRound": "Starta runda",
    "updateCta": "Spara och fortsätt",
    "tournamentManagedLocked": "Turneringsstyrt"
  },
  "roundStartSetup": {
    "title": "Rondinställningar",
    "subtitleNamed": "Konfigurera spelare och spel för {name}",
    "subtitleFallback": "Konfigurera spelare och spel för den här rundan",
    "loading": "Laddar rondstart...",
    "loadError": "Kunde inte ladda rondstart.",
    "playersTitle": "Rondspelare",
    "playersEmpty": "Inga spelare kopplade till rundan.",
    "playingHandicapLabel": "Spel-hcp",
    "playingHandicapPlaceholder": "Play HCP",
    "groupsTitle": "Grupper och lag",
    "groupsHint": "Dra ett spelarkort till ett annat kort för att byta, eller tryck först på ett kort och sedan på ett annat.",
    "groupsLocked": "Grupper är låsta när rundan inte längre är utkast.",
    "groupsEmpty": "Ingen grupplayout tillgänglig.",
    "groupLabel": "Grupp {index}",
    "teamLabel": "Lag {index}",
    "groupsUpdateSending": "Sparar gruppbyte...",
    "groupsUpdateSaved": "Grupper uppdaterade.",
    "groupsUpdateQueued": "Gruppbyte köat tills websocket är tillbaka.",
    "groupsUpdateRejected": "Kunde inte uppdatera grupper.",
    "groupsUpdateSendFailed": "Kunde inte skicka gruppbyte.",
    "groupsUpdateTimeout": "Tidsgräns nåddes för bekräftelse av gruppbyte.",
    "gamesTitle": "Rondspel",
    "gamesEmpty": "Inga spel kopplade till rundan.",
    "addMoreGamesCta": "Lägg till fler spel",
    "removePlayerCta": "Ta bort",
    "removingPlayer": "Tar bort spelare...",
    "removeQueued": "Borttagning av spelare köad.",
    "removeSent": "Spelaren är borttagen.",
    "removeRejected": "Det gick inte att ta bort spelaren från rundan.",
    "disableGameCta": "Inaktivera",
    "enableGameCta": "Aktivera",
    "gamesUpdateQueued": "Ronduppdatering köad.",
    "gamesUpdateSent": "Rondspel uppdaterade.",
    "updateCta": "Uppdatera",
    "openRoundCta": "Öppna runda",
    "openRoundSending": "Öppnar runda...",
    "openRoundQueued": "Rundans statusuppdatering köad.",
    "openRoundConfirmed": "Rundan är nu aktiv.",
    "openRoundSendFailed": "Kunde inte skicka rundans statusuppdatering.",
    "openRoundTimeout": "Rundan blev inte aktiv i tid. Försök igen."
  },
  "tourLeaderboard": {
    "title": "Tourleaderboard",
    "tourName": "Tour: {name}",
    "roundCount": "Rundor: {count}",
    "points": "{points} p",
    "player": "Spelare",
    "total": "Tour",
    "gameFallback": "Spel",
    "roundsTitle": "Rundor",
    "roundSectionsTitle": "Rundor",
    "roundSectionTitle": "Runda {round}: {name}",
    "roundMembersEmpty": "Inga medlemmar i den här rundan.",
    "roundRowLabel": "Runda",
    "roundFallback": "Runda",
    "roundEmpty": "Inga poäng ännu.",
    "empty": "Inga resultat ännu.",
    "missingTour": "Ingen tour vald.",
    "goTours": "Gå till tours",
    "loadError": "Kunde inte ladda leaderboard.",
    "wsConnecting": "Ansluter till live leaderboard...",
    "wsWaitingData": "Ansluten. Väntar på leaderboard-data...",
    "wsRetrying": "Väntar fortfarande på leaderboard-data (försök {count}).",
    "unknownPlayer": "Okänd spelare",
    "resultsHeader": "Resultat",
    "resultsButton": "Graf",
    "resultsTitle": "Tourresultat",
    "resultsTableTitle": "Resultattabell",
    "resultsClose": "Stäng",
    "resultsError": "Kunde inte ladda resultat.",
    "resultsTableButton": "Tabell",
    "downloadCsv": "Ladda ner CSV",
    "csvError": "Inga tourresultat att ladda ner.",
    "csvUnsupported": "CSV-nedladdning finns bara på webben.",
    "roundPoints": "Rondpoäng",
    "claimHeader": "Claima",
    "claimCta": "Claima",
    "claiming": "Claimar...",
    "claimPending": "Begäran om claim skickad.",
    "claimSuccess": "Spelaren är nu claimad till din profil.",
    "claimRejected": "Det gick inte att claima spelaren.",
    "claimSendError": "Kunde inte skicka claim-begäran.",
    "claimReleaseCta": "Avbryt claim",
    "claimReleaseSendError": "Kunde inte avbryta claim.",
    "claimReleased": "Claimen är avbruten.",
    "waitingForRoundSetupTitle": "Rundans Setup Pågår",
    "waitingForRoundSetup": "Väntar på att rundans setup ska bli klar. Du skickas automatiskt till hål 1.",
    "membersTitle": "Tourmedlemmar",
    "membersClaimHint": "Claima tillfälliga medlemmar här.",
    "membersReadOnlyHint": "Logga in för att claima tillfälliga medlemmar.",
    "unassignedPlayersTitle": "Oclaimade spelare",
    "unassignedPlayersHint": "Välj din spelare för att börja registrera score.",
    "unassignedPlayersEmpty": "Inga oclaimade spelare kvar.",
    "membersEmpty": "Inga medlemmar i den här touren.",
    "memberTemporary": "Tillfällig medlem",
    "memberClaimed": "Kopplad medlem"
  },
  "scorecard": {
    "title": "Scorekort",
    "player": "Spelare",
    "hole": "Hål",
    "par": "Par",
    "index": "Index",
    "strokes": "Slag",
    "points": "Poäng",
    "out": "Ut",
    "in": "In",
    "total": "Totalt",
    "totalGross": "Slag",
    "totalStableford": "Poäng",
    "selectRoundTitle": "Välj runda",
    "selectRoundLoading": "Laddar rundor...",
    "selectRoundEmpty": "Inga rundor tillgängliga.",
    "selectRound": "Välj",
    "selectRoundError": "Kunde inte ladda rundor.",
    "selectRoundFallback": "Runda",
    "missingRound": "Ingen runda vald.",
    "loadError": "Kunde inte ladda scorekort."
  },
  "language": {
    "english": "Engelska",
    "label": "Språk",
    "swedish": "Svenska",
    "danish": "Danska"
  },
  "modal": {
    "title": "Modal"
  },
  "notFound": {
    "cta": "Gå till startskärmen!",
    "message": "Den här skärmen finns inte.",
    "title": "hoppsan!"
  },
  "qr": {
    "fallbackError": "Använder reservlänk eftersom backend inte är tillgänglig.",
    "subtitle": "Eller tryck nedan för att öppna den direkt",
    "title": "Skanna för att öppna länken"
  },
  "tab": {
    "qr": "QR-länk",
    "players": "Spelare"
  },
  "players": {
    "addedAt": "Tillagt:{date}",
    "empty": "Inga spelare ännu.",
    "loadError": "Det gick inte att ladda spelare.",
    "serviceError": "Players service error",
    "title": "Spelare",
    "roundInitTitle": "Ny runda",
    "wsError": "WebSocket-anslutningen misslyckades.",
    "tourId": "Tour-ID: {id}",
    "tourNameFallback": "Tour",
    "activeRoundsTitle": "Aktiva rundor",
    "activeRoundsRefresh": "Uppdatera",
    "activeRoundsEmpty": "Inga aktiva rundor hittades.",
    "roundsLoadError": "Det gick inte att ladda rundor.",
    "roundStatus": "Status: {status}",
    "roundStatusWithDate": "Status: {status} · {date}",
    "roundOpen": "Öppna",
    "roundContinue": "Fortsätt",
    "roundFallbackName": "Bana",
    "finishedRoundsTitle": "Avslutade rundor",
    "roundResults": "Resultat",
    "roundMenuLabel": "Rondåtgärder",
    "roundMenuPause": "Pausa",
    "roundMenuFinish": "Avsluta",
    "roundMenuCancel": "Avbryt",
    "roundNamePlaceholder": "Rondnamn",
    "roundDescriptionTitle": "Rondbeskrivning",
    "roundDescriptionPlaceholder": "Lägg till en beskrivning...",
    "roundDescriptionButton": "Redigera rondbeskrivning",
    "playDateLabel": "Speldatum",
    "playDateQuick": "Snabba datum",
    "playDateToday": "Idag",
    "holesCountLabel": "Antal hål",
    "courseLabel": "Bana",
    "courseSearchPlaceholder": "Sök bana",
    "courseSearchEmpty": "Inga banor hittades.",
    "addCourse": "Lägg till bana",
    "holesCountOptionLabel": "{count} hål",
    "holesCountOptionValue": "{count} hål",
    "teeLabel": "Tee",
    "teeNone": "Ingen",
    "addTemporary": "Lägg till tillfällig spelare",
    "temporaryNamePlaceholder": "Namn på tillfällig spelare",
    "temporaryCreateAction": "Skapa spelare",
    "temporaryNameRequired": "Ange namn för tillfällig spelare.",
    "temporaryCreateFailed": "Det gick inte att skapa tillfällig spelare.",
    "temporaryCreatePending": "Vänta tills tillfälliga spelare är skapade innan rundan startas.",
    "temporaryCreatePendingCount": "Skapar tillfälliga spelare: {count}",
    "inviteOthers": "Bjud in andra",
    "joinWithCode": "Gå med med kod",
    "showQr": "Visa QR",
    "selectFromMembership": "Välj spelare från tourens medlemslista.",
    "membersUpdateTimeout": "Ingen bekräftelse för uppdatering av tourmedlemmar.",
    "membersUpdateSendFailed": "Det gick inte att skicka uppdatering av tourmedlemmar.",
    "roundInitiateSendFailed": "Det gick inte att starta rundan.",
    "roundInitiateTimeout": "Start av runda tog för lång tid.",
    "roundInitiateRejected": "Start av runda nekades.",
    "missingTour": "Tour saknas, kan inte spara spelare.",
    "singleRoundHiddenTourName": "Enkel runda",
    "hiddenTourInitiateFailed": "Det gick inte att starta enkel runda just nu."
  },
  "round": {
    "member": {
      "add": {
        "alreadyMember": "Spelaren ingår redan i den här rundan.",
        "playerNotInTour": "Spelaren måste vara medlem i touren innan den kan läggas till i rundan.",
        "statusNotAllowed": "Spelare kan bara läggas till när rundans status är draft, active eller playing.",
        "roundNotFound": "Rundan kunde inte hittas.",
        "invalid": "Begäran om tillägg av rundspelare är ogiltig."
      },
      "remove": {
        "invalid": "Begäran om borttagning av rundspelare är ogiltig.",
        "invalidPlayer": "Borttagning av rundspelare kräver en giltig spelare.",
        "roundNotFound": "Rundan kunde inte hittas.",
        "notMember": "Spelaren ingår inte i den här rundan.",
        "lastPlayer": "En runda måste ha minst en spelare kvar.",
        "hasScores": "Spelaren kan inte tas bort från rundan efter att scorer har registrerats."
      }
    },
    "remove": {
      "invalid": "Begäran om borttagning av runda är ogiltig.",
      "roundNotFound": "Rundan kunde inte hittas.",
      "hasScores": "Rundan kan inte tas bort efter att scorer har registrerats."
    },
    "initiate": {
      "membershipRequired": "Alla rundspelare måste vara medlemmar i touren."
    }
  },
  "roundResults": {
    "title": "Rundresultat",
    "backToHole": "<- Rondresultat",
    "missingRound": "Välj en runda för att se resultat.",
    "goPlayers": "Till spelare",
    "loadError": "Kunde inte ladda rundresultat.",
    "empty": "Inga resultat än.",
    "player": "Namn",
    "total": "Poäng",
    "gameFallback": "Spel",
    "unknownPlayer": "Spelare",
    "roundFallback": "Runda",
    "status": "Status: {status}"
  },
  "summary": {
    "title": "Rondsammanfattning",
    "missingInfo": "Saknar rond-ID eller användartoken.",
    "loadError": "Kunde inte ladda ronddata.",
    "overallTitle": "Total leaderboard",
    "playerHeader": "Spelare",
    "scoreHeader": "Score",
    "gameHeader": "Game",
    "pointsHeader": "Totalpoäng",
    "gamesTitle": "Resultat per spel",
    "gamesEmpty": "Inga spelresultat ännu.",
    "hazardsTitle": "Hazardspel",
    "hazardsEmpty": "Inga hazard-händelser registrerade.",
    "hazardTotal": "Totalt {count}",
    "hazardWater": "Vatten {count}",
    "hazardBunker": "Bunker {count}",
    "hazardThreePutt": "3-putt {count}",
    "hazardPenalty": "Straff {count}",
    "pointsValue": "{points} p",
    "mysteryTitle": "Mystery-spel höjdpunkter",
    "mysteryEmpty": "Inga mystery-val hittades.",
    "mysteryHolePrize": "Hål {hole} - {prize}",
    "mysterySubgame": "Delspel: {subgame}",
    "mysteryWinner": "Vinnare: {winner}",
    "mysteryPrizeFallback": "Mystery-pris",
    "parBetterTitle": "Par eller bättre per spelare",
    "parBetterEmpty": "Inga par-eller-bättre resultat ännu.",
    "parBetterHoles": "Hål: {holes}",
    "parBetterHolesWithResult": "Hål: {holes}",
    "resultPar": "par",
    "resultBirdie": "birdie",
    "resultEagle": "eagle",
    "resultAlbatross": "albatross",
    "resultUnderPar": "under par",
    "unknownPlayer": "Okänd spelare",
    "unknownGame": "Okänt spel",
    "unknownWinner": "Okänd vinnare",
    "unknownMysteryPrize": "Okänt mystery-pris",
    "doneButton": "Klar"
  },
  "tour": {
    "member": {
      "claim": {
        "invalid": "Begäran om att claima tourspelare är ogiltig.",
        "unauthorized": "Logga in för att claima spelaren.",
        "tourNotFound": "Touren kunde inte hittas.",
        "sourceNotFound": "Spelaren kunde inte hittas.",
        "sourceNotMember": "Spelaren ingår inte i den här touren.",
        "sourceNotUnclaimed": "Spelaren är redan claimad.",
        "targetMissing": "Skapa din spelarprofil innan du claimar den här spelaren.",
        "targetAlreadyInTour": "Din spelare är redan med i den här touren.",
        "targetAlreadyInRound": "Din spelare finns redan i en eller flera rundor i den här touren.",
        "mergeConflict": "Claim kunde inte slutföras eftersom ronddata krockar med din befintliga spelare."
      },
      "remove": {
        "invalid": "Begäran om borttagning av tourspelare är ogiltig.",
        "invalidPlayer": "Borttagning av tourspelare kräver en giltig spelare.",
        "tourNotFound": "Touren kunde inte hittas.",
        "notMember": "Spelaren ingår inte i den här touren.",
        "creatorProtected": "Tourens skapare kan inte tas bort.",
        "lastMember": "En tour måste ha minst en medlem kvar.",
        "roundLastPlayer": "Spelaren kan inte tas bort eftersom en runda då blir tom.",
        "hasScores": "Spelaren kan inte tas bort från touren efter att scorer har registrerats."
      }
    },
    "initiate": {
      "creatorPlayerRequired": "Skapa din spelarprofil innan du skapar en tour.",
      "invalidPlayers": "En eller flera valda spelare kunde inte hittas.",
      "maxPlayersExceeded": "En tour kan ha max 8 spelare."
    }
  },
  "mysteryPrize": {
    "title": "Mysterypris",
    "subtitle": "Välj ett hål och ett delspel för varje spelare.",
    "loading": "Laddar mystery-setup...",
    "loadError": "Kunde inte ladda mysterypriset.",
    "validationError": "Välj ett hål och ett delspel för varje spelare.",
    "noPlayers": "Inga spelare hittades för rundan.",
    "noSubgames": "Inga delspel tillgängliga.",
    "holeLabel": "Hål",
    "subgameLabel": "Delspel",
    "selectHole": "Välj hål",
    "selectSubgame": "Välj delspel",
    "save": "Spara mysterypris",
    "saving": "Sparar...",
    "holePickerTitle": "Välj hål",
    "subgamePickerTitle": "Välj delspel"
  },
  "hole": {
    "title": "Hål",
    "scoreButtonLabel": "Score",
    "scorePopupTitle": "{name} - {holeLabel} {hole}",
    "scorePopupHandicapLabel": "Handicapslag {value}",
    "scorePopupHandicapAndIndexLabel": "Handicapslag {handicap} · Hcp-index {index}",
    "scorePopupMeta": "Hcp-index {hcpIndex} · Par {par}",
    "placeholder": "Poängregistrering kommer här.",
    "roundId": "Rond: {id}",
    "tourId": "Tour: {id}",
    "gameFallbackName": "Spel",
    "playerBreakdownTitle": "Poäng för {name}",
    "playerBreakdownEmpty": "Inga poäng att visa.",
    "positionShort": "Plats {position}",
    "positionShared": "delad",
    "roundPointsMissing": "-",
    "leaderboardShortTitle": "Leaderboard",
    "roundColumn": "Rond",
    "tourColumn": "Tour",
    "leaderboardRoundTitle": "⛳️ Leaderboard - rond (Tour)",
    "noGamesSelected": "Inga spel valda. Leaderboarden är dold.",
    "unknownPlayer": "Okänd spelare",
    "gamesTitle": "🏆 Spel",
    "mysteryPrizeTitle": "Mysterypris",
    "missingRound": "Ingen runda vald.",
    "goPlayers": "Gå till spelare",
    "mysteryPrizeEntry": "{subgame} - {player}",
    "mysteryPrizeEntryWinner": "{subgame} - {player} (vinnare {winner})",
    "mysteryPrizeNone": "Inget mysterypris för det här hålet.",
    "noPlayers": "Inga spelare att visa.",
    "puttOne": "1 putt",
    "puttTwo": "2 puttar",
    "puttThree": "3 puttar",
    "puttPlus": "+ puttar",
    "eightPlusLabelWithValue": "8+({value})",
    "mysteryPrizeUnknownSubgame": "Okänt delspel",
    "mysteryPrizeUnknownPlayer": "Okänd spelare",
    "mysteryPrizeWinnerTitle": "Välj vinnare",
    "mysteryPrizeNextHoleTitle": "Mysterypris nästa hål",
    "mysteryPrizeNextHoleSubtitle": "På hål {hole} är mysterypriserna valda så här:",
    "mysteryPrizeSelectWinner": "Välj vinnare",
    "mysteryPrizeBack": "Tillbaka",
    "backButton": "<- Tillbaka",
    "showDetails": "Visa detaljer",
    "hideDetails": "Dölj detaljer",
    "pickup": "Pickup",
    "roundStateTitle": "Round state",
    "roundStateEmpty": "Ingen round state mottagen.",
    "close": "Stäng",
    "netScoreLabel": "Netto",
    "netSummary": "Netto {net}{vsPar}",
    "netSummaryEmpty": "Netto –",
    "stablefordLabel": "Stableford",
    "menuTitle": "Välj hål",
    "menuButton": "Hål {hole}",
    "menuPlayed": "Spelat",
    "menuNotPlayed": "Ej spelat",
    "menuMyScore": "Min score: {score}",
    "menuScoreMissing": "—",
    "menuCurrent": "Aktuellt hål",
    "prevHole": "Föregående hål",
    "prevHoleSwipeHint": "Svep igen för att gå till föregående hål.",
    "nextHole": "Nästa hål",
    "nextHoleSwipeHint": "Svep igen för att gå till nästa hål.",
    "finishRound": "Avsluta rond",
    "finishRoundHint": "Tryck för att avsluta rundan.",
    "finishSendFailed": "Det gick inte att avsluta rundan.",
    "eventSendFailed": "Det gick inte att skicka händelsen.",
    "event": {
      "water": "Vatten",
      "penalty": "Straff",
      "bunker": "Bunker",
      "threePutt": "3 puttar"
    },
    "parBadge": "Par {par}",
    "hcpIndexBadge": "Index {hcpIndex}",
    "playersLoadFailed": "Kunde inte hämta spelare."
  },
  "games": {
    "definitions": {
      "stableford": {
        "name": "Stableford",
        "info": "Poängspel baserat på resultat mot par per hål.",
        "description": "Spelare får poäng per hål utifrån nettresultat mot par."
      },
      "skins": {
        "name": "Skins",
        "info": "Varje hål är värt en skin.",
        "description": "Bästa score på hålet vinner skin; delning rullar över till nästa hål."
      },
      "best-ball": {
        "name": "Best Ball",
        "info": "Lagformat som räknar bästa score per hål.",
        "description": "Varje lag räknar sin bästa spelares score på varje hål."
      },
      "bunker": {
        "name": "Bunker",
        "info": "Händelsespel för bunkerutfall.",
        "description": "Spårar bunkerhändelser under rundan."
      },
      "water": {
        "name": "Vatten",
        "info": "Händelsespel för vattenhinder.",
        "description": "Spårar vattenhinderhändelser under rundan."
      },
      "3-putts": {
        "name": "3 puttar",
        "info": "Händelsespel för treputtar.",
        "description": "Spårar hål där spelare behöver tre puttar."
      },
      "closest-to-flag": {
        "name": "Närmast flagg",
        "info": "Utmaningsspel för precision på utvalda hål.",
        "description": "Spelaren närmast flaggan vinner utmaningen på valt hål."
      },
      "longest-1-put": {
        "name": "Längsta 1 putt",
        "info": "Utmaningsspel för längsta enputt.",
        "description": "Längsta lyckade enputt vinner på valt hål."
      },
      "longest-drive": {
        "name": "Längsta drive",
        "info": "Utmaningsspel för utslagslängd.",
        "description": "Längsta giltiga drive vinner på valt hål."
      },
      "b1f4b6d5-3a7e-4d0a-8d3b-2e4f6a7b8c9d": {
        "name": "Mystery-pris",
        "info": "Hemligt sidospel med valt delspel och hål.",
        "description": "Varje spelare får ett dolt delspel för ett valt hål, sedan utses en vinnare."
      }
    },
    "subgames": {
      "d4d2a4b1-5a9b-4f0d-9b94-1a8f8a5c2e11": {
        "name": "Närmast flagg",
        "description": "Närmast flaggan på det valda hålet."
      },
      "3e92a03c-5b70-4a3a-aad1-7db36de37d5e": {
        "name": "Längsta drive",
        "description": "Längsta drive på det valda hålet."
      },
      "7c1cfd58-9171-4b4a-9a71-6f1d8b9b5c30": {
        "name": "Längsta 1 putt",
        "description": "Längsta enputt på det valda hålet."
      }
    }
  }
}
